module.exports = __webpack_public_path__ + "app/assets/images/close-menu.png";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/close-menu.png
// module id = 280
// module chunks = 7